<template>
    <div class="visual-container">
        <el-tree
            :data="treeData"
            node-key="id"
            default-expand-all
        >
            <span class="custom-tree-node" slot-scope="{ node, data }">
                <i v-if="['iconAndName', 'icon'].includes(element.style.displayMode)" :class="data.icon || ''"></i>
                <span v-if="['iconAndName', 'name'].includes(element.style.displayMode)">{{ node.label }}</span>
            </span>
        </el-tree>
        <div class="visual-mask"></div>
    </div>
</template>

<script>
export default {
    props: {
        element: {
            type: Object,
            default: () => {},
        },
        isPreview: Boolean,
            currentComps: {
            type: String,
            require: false
        }
    },
    data() {
        return {
            treeData: [
                { id: 1, label: '全部', icon: 'el-icon-s-grid', children: [
                    { id: 2, label: '文件1', icon: 'el-icon-document' },
                    { id: 3, label: '文件2', icon: 'el-icon-notebook-2' }
                ] }
            ]
        };
    }
}
</script>
<style lang="scss">
.visual-container {
    .el-tree {
        background: transparent;
        color: inherit;
    }
}
</style>
<style lang="scss" scoped>
.visual-container {
    position: relative;
    background-size: 100% 100%;
    .visual-mask {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 3;
        top: 0px;
        left: 0px;
    }
}
</style>